import React from 'react';
import './BankSurveyAnalytics.css';

function getSatisfactionColor(rating) {
  if (rating >= 4) return 'badge-positive';
  if (rating >= 3) return 'badge-pending';
  return 'badge-negative';
}

function getNpsColor(nps) {
  if (nps >= 50) return 'badge-positive';
  if (nps >= 0) return 'badge-pending';
  return 'badge-negative';
}

export default function BankSurveyAnalytics({ analytics }) {
  if (!analytics) {
    return <div className="loading">Loading analytics...</div>;
  }

  const {
    total,
    avg_satisfaction,
    avg_nps_score,
    nps,
    nps_breakdown,
    outcome_breakdown,
  } = analytics;

  const promoterPct = total > 0 ? ((nps_breakdown.promoters / total) * 100).toFixed(0) : 0;
  const passivePct = total > 0 ? ((nps_breakdown.passives / total) * 100).toFixed(0) : 0;
  const detractorPct = total > 0 ? ((nps_breakdown.detractors / total) * 100).toFixed(0) : 0;

  return (
    <div className="card bank-survey-analytics">
      <h3>FNB Ghana Survey Overview</h3>
      <div className="grid grid-4" style={{ marginBottom: '1rem' }}>
        <div className="analytics-stat">
          <div className="stat-value">{total}</div>
          <div className="stat-label">Total Responses</div>
        </div>
        <div className="analytics-stat">
          <div className={`stat-value ${getSatisfactionColor(avg_satisfaction)}-text`}>
            {avg_satisfaction > 0 ? avg_satisfaction.toFixed(1) : '\u2014'}
            <span className="stat-scale"> / 5</span>
          </div>
          <div className="stat-label">Avg Satisfaction</div>
        </div>
        <div className="analytics-stat">
          <div className={`stat-value ${getNpsColor(nps)}-text`}>
            {total > 0 ? (nps > 0 ? '+' : '') + nps.toFixed(0) : '\u2014'}
          </div>
          <div className="stat-label">NPS Score</div>
        </div>
        <div className="analytics-stat">
          <div className="stat-value">
            {avg_nps_score > 0 ? avg_nps_score.toFixed(1) : '\u2014'}
            <span className="stat-scale"> / 10</span>
          </div>
          <div className="stat-label">Avg Recommendation</div>
        </div>
      </div>

      {total > 0 && (
        <>
          <div className="nps-section">
            <div className="nps-bar-container">
              <div className="nps-segment nps-promoter" style={{ width: `${promoterPct}%` }}>
                {promoterPct > 10 && `${promoterPct}%`}
              </div>
              <div className="nps-segment nps-passive" style={{ width: `${passivePct}%` }}>
                {passivePct > 10 && `${passivePct}%`}
              </div>
              <div className="nps-segment nps-detractor" style={{ width: `${detractorPct}%` }}>
                {detractorPct > 10 && `${detractorPct}%`}
              </div>
            </div>
            <div className="nps-legend">
              <span className="nps-legend-item">
                <span className="nps-dot nps-promoter-dot" /> Promoters ({nps_breakdown.promoters})
              </span>
              <span className="nps-legend-item">
                <span className="nps-dot nps-passive-dot" /> Passives ({nps_breakdown.passives})
              </span>
              <span className="nps-legend-item">
                <span className="nps-dot nps-detractor-dot" /> Detractors ({nps_breakdown.detractors})
              </span>
            </div>
          </div>

          <div className="outcome-badges">
            {Object.entries(outcome_breakdown).map(([outcome, count]) => (
              <span key={outcome} className="badge badge-neutral" style={{ marginRight: '0.5rem' }}>
                {outcome.replace('_', ' ')}: {count}
              </span>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
